import { Module } from 'framework/core';

import { CartAPI } from './cart.api';

@Module({
  providers: [CartAPI],
})
export class CartModule {}
